module.exports = "/_next/static/images/005fa888ea17abfed2307716d46f31eb-computer-desk-man@md-1x.jpg";